export default [
  {
    path: '/resources/price-sheets',
    name: 'PriceSheets',
    component: () => import('../views/PriceSheets.vue')
  }
]
